import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as r, createStaticVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGoogleDrive",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, n = ["aria-label", "data-qa", "aria-hidden"], h = /* @__PURE__ */ o('<path d="m3.512 18.315.882 1.524c.183.32.447.572.756.756.886-1.125 1.503-1.988 1.85-2.59.353-.61.786-1.564 1.3-2.863-1.385-.182-2.435-.273-3.15-.273-.686 0-1.736.09-3.15.273 0 .355.092.71.275 1.031l1.237 2.142z" fill="#0066DA"></path><path d="M18.85 20.595a2.08 2.08 0 0 0 .756-.756l.367-.63 1.752-3.036c.18-.314.275-.67.275-1.03-1.422-.183-2.47-.274-3.144-.274-.724 0-1.772.09-3.145.273.508 1.306.936 2.26 1.283 2.864.35.608.97 1.471 1.856 2.589z" fill="#EA4335"></path><path d="M12 8.727c1.025-1.237 1.732-2.192 2.12-2.863.312-.54.655-1.404 1.03-2.59A2.014 2.014 0 0 0 14.12 3H9.88a2.13 2.13 0 0 0-1.031.275c.477 1.36.882 2.327 1.214 2.903.368.636 1.013 1.486 1.936 2.55z" fill="#00832D"></path><path d="M15.7 15.142H8.3l-3.15 5.453c.31.183.664.275 1.031.275h11.638a2.14 2.14 0 0 0 1.031-.275l-3.15-5.453z" fill="#2684FC"></path><path d="M12 8.727 8.85 3.275a2.08 2.08 0 0 0-.756.756l-5.82 10.08c-.179.314-.274.67-.274 1.031h6.3L12 8.727z" fill="#00AC47"></path><path d="m18.816 9.071-2.91-5.04a2.08 2.08 0 0 0-.756-.756L12 8.727l3.7 6.415h6.289c0-.355-.092-.71-.275-1.03l-2.898-5.04z" fill="#FFBA00"></path>', 6), p = [
  h
];
function _(e, f, i, m, u, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--google-drive"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Drive",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, p, 10, n);
}
const b = /* @__PURE__ */ s(c, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=google-drive.js.map
